import { SlidersOutlined } from '@ant-design/icons';

const AiColumnHeader = () => (
    <span className="flex w-full items-center justify-between gap-2">
        <span className="font-semibold text-[#18181b]">AI</span>
        <SlidersOutlined className="text-[12px] text-[rgba(0,0,0,0.45)]" />
    </span>
);

export default AiColumnHeader;
